<template>
    <div class="form">
        <!--步骤条-->
        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--公安机关选择-->
            <select-police :matterInfo="matterInfo" :informationShowData="informationShowData"
                           :declareInfo="declareInfo" ref="selectpolice"></select-police>
            <!--基本信息-->
            <p class="title">申请人信息</p>
            <van-cell-group class="approve-company-box">
                <van-field required readonly label="姓名" :value="declareInfo.body.sqrxm"
                           input-align="right"/>
                <van-field required label="居民身份证号" input-align="right"
                           :value="declareInfo.body.sqrjmsfzh"
                           readonly/>
                <van-field required label="手机号码" v-model="declareInfo.body.sqrlxdh" input-align="right"/>
                <p class="title" style="background:RGB(242,242,241)">法人代表信息</p>
                <van-field required  label="姓名" v-model = "declareInfo.body.frxm"
                           input-align="right"/>
                <van-field required label="居民身份证号" input-align="right"
                           v-model = "declareInfo.body.frjmsfzh" />
                <van-field required label="手机号码" v-model="declareInfo.body.frlxdh" input-align="right"/>

                <van-field v-model="address.gj" label="家庭地址:"  is-link readonly input-align="right"
                />
                <van-field v-model="address.shengfen1" label="选择省份:" placeholder="请选择省份" is-link required readonly
                           input-align="right"
                           @click="showPickerHJProvince1 = true"/>
                <van-popup v-model="showPickerHJProvince1" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showPickerHJProvince1 = false"
                                @confirm="onConfirmHJProvince1"/>
                </van-popup>
                <van-field v-model="address.shiqu1" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showPickerHJCity1 = true" v-if="HJCityShow1"/>
                <van-popup v-model="showPickerHJCity1" position="bottom">
                    <van-picker :columns="cityHJList1" show-toolbar value-key="title" @cancel="showPickerHJCity1 = false"
                                @confirm="onConfirmHJCity1"/>
                </van-popup>
                <van-field v-model="address.quxian1" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showPickerHJArea1 = true" v-if="HJAreaShow1"/>
                <van-popup v-model="showPickerHJArea1" position="bottom">
                    <van-picker :columns="areaHJList1" show-toolbar value-key="title" @cancel="showPickerHJArea1 = false"
                                @confirm="onConfirmHJArea1"/>
                </van-popup>
                <van-field input-align="right" type="textarea" v-model="declareInfo.body.frjtzz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
                <p class="title" style="background:RGB(242,242,241)">主要负责人信息</p>
                <van-field required  label="姓名" v-model = "declareInfo.body.zyfzrxm"
                           input-align="right"/>
                <van-field required label="居民身份证号" input-align="right"
                           v-model = "declareInfo.body.zyfzrjmsfzh" />
                <van-field required label="手机号码" v-model="declareInfo.body.zyfzrlxdh" input-align="right"/>

                <van-field v-model="address.gj" label="家庭地址:"  is-link readonly input-align="right"
                />
                <van-field v-model="address.shengfen2" label="选择省份:" placeholder="请选择省份" is-link required readonly
                           input-align="right"
                           @click="showPickerHJProvince2 = true"/>
                <van-popup v-model="showPickerHJProvince2" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showPickerHJProvince2 = false"
                                @confirm="onConfirmHJProvince2"/>
                </van-popup>
                <van-field v-model="address.shiqu2" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showPickerHJCity2 = true" v-if="HJCityShow1"/>
                <van-popup v-model="showPickerHJCity2" position="bottom">
                    <van-picker :columns="cityHJList2" show-toolbar value-key="title" @cancel="showPickerHJCity2 = false"
                                @confirm="onConfirmHJCity2"/>
                </van-popup>
                <van-field v-model="address.quxian2" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showPickerHJArea2 = true" v-if="HJAreaShow1"/>
                <van-popup v-model="showPickerHJArea2" position="bottom">
                    <van-picker :columns="areaHJList2" show-toolbar value-key="title" @cancel="showPickerHJArea2 = false"
                                @confirm="onConfirmHJArea2"/>
                </van-popup>
                <van-field input-align="right" type="textarea" v-model="declareInfo.body.zyfzrjtzz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
                <p class="title" style="background:RGB(242,242,241)">保卫负责人信息</p>
                <van-field required  label="姓名" v-model = "declareInfo.body.bwfzrxm"
                           input-align="right"/>
                <van-field required label="居民身份证号" input-align="right"
                           v-model = "declareInfo.body.bwfzrjmsfzh" />
                <van-field required label="手机号码" v-model="declareInfo.body.bwfzrlxdh" input-align="right"/>

                <van-field v-model="address.gj" label="家庭地址:"  is-link readonly input-align="right"
                />
                <van-field v-model="address.shengfen3" label="选择省份:" placeholder="请选择省份" is-link required readonly
                           input-align="right"
                           @click="showPickerHJProvince3 = true"/>
                <van-popup v-model="showPickerHJProvince3" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showPickerHJProvince3 = false"
                                @confirm="onConfirmHJProvince3"/>
                </van-popup>
                <van-field v-model="address.shiqu3" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showPickerHJCity3 = true" v-if="HJCityShow1"/>
                <van-popup v-model="showPickerHJCity3" position="bottom">
                    <van-picker :columns="cityHJList3" show-toolbar value-key="title" @cancel="showPickerHJCity3 = false"
                                @confirm="onConfirmHJCity3"/>
                </van-popup>
                <van-field v-model="address.quxian3" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showPickerHJArea3 = true" v-if="HJAreaShow3"/>
                <van-popup v-model="showPickerHJArea3" position="bottom">
                    <van-picker :columns="areaHJList3" show-toolbar value-key="title" @cancel="showPickerHJArea3 = false"
                                @confirm="onConfirmHJArea3"/>
                </van-popup>
                <van-field input-align="right" type="textarea" v-model="declareInfo.body.bwfzrjtzz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>

                <p class="title" style="background:RGB(242,242,241)">单位信息</p>
                <van-field required label="营业执照名称" input-align="right" v-model="declareInfo.body.yyzzmc"
                           placeholder="请输入营业执照名称" clearable/>
                <van-field required label="旅馆招牌名称" input-align="right" v-model="declareInfo.body.lgzpmc"
                           placeholder="请输入旅馆招牌名称" clearable/>
                <van-field required label="营业执照编号" input-align="right" v-model="declareInfo.body.yyzzhm"
                           placeholder="请输入营业执照编号" clearable/>
                <van-field required label="邮政编码" input-align="right" v-model="declareInfo.body.yzbm"
                           placeholder="请输入邮政编码" clearable/>
                <van-field v-model="address.gj" label="单位标准地址:"  is-link readonly input-align="right"
                />
                <van-field v-model="address.shengfen4" label="选择省份:" placeholder="请选择省份" is-link required readonly
                           input-align="right"
                           @click="showPickerHJProvince4 = true"/>
                <van-popup v-model="showPickerHJProvince4" position="bottom">
                    <van-picker :columns="provinceList" show-toolbar value-key="title"
                                @cancel="showPickerHJProvince4 = false"
                                @confirm="onConfirmHJProvince4"/>
                </van-popup>
                <van-field v-model="address.shiqu4" placeholder="请选择市区" is-link readonly input-align="right"
                           @click="showPickerHJCity4 = true" v-if="HJCityShow4"/>
                <van-popup v-model="showPickerHJCity4" position="bottom">
                    <van-picker :columns="cityHJList4" show-toolbar value-key="title" @cancel="showPickerHJCity4 = false"
                                @confirm="onConfirmHJCity4"/>
                </van-popup>
                <van-field v-model="address.quxian4" placeholder="请选择区县" is-link readonly input-align="right"
                           @click="showPickerHJArea4 = true" v-if="HJAreaShow2"/>
                <van-popup v-model="showPickerHJArea4" position="bottom">
                    <van-picker :columns="areaHJList4" show-toolbar value-key="title" @cancel="showPickerHJArea4 = false"
                                @confirm="onConfirmHJArea4"/>
                </van-popup>
                <van-field input-align="right" type="textarea" v-model="declareInfo.body.lgbzdz"
                           placeholder="请输入区划内详细地址" rows="1" autosize clearable/>

                <van-field required label="旅馆附属场所" input-align="right" v-model="declareInfo.body.lgfscs"
                           placeholder="请输入旅馆附属场所" clearable/>

                <van-field required label="单位电话" input-align="right" v-model="declareInfo.body.dwmc"
                           placeholder="请输入单位电话" clearable/>

                <van-field required label="注册资金" input-align="right" v-model="declareInfo.body.zczj"
                           placeholder="请输入注册资金" clearable/>

                <van-field required label="建筑结构" input-align="right"
                           v-model="declareInfo.body.jzjg" clearable/>

                <van-field required label="营业面积" input-align="right"
                           v-model="declareInfo.body.yymj" clearable/>

                <van-field required label="客房数" input-align="right"
                           v-model="declareInfo.body.kfs" clearable/>

                <van-field required label="床位数" input-align="right"
                           v-model="declareInfo.body.cws" clearable/>

                <van-field required label="从业人数" input-align="right"
                           v-model="declareInfo.body.cyrs" clearable/>

                <van-field required label="保卫人数" input-align="right"
                           v-model="declareInfo.body.bwrs" clearable/>
            </van-cell-group>
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
        <div v-show="active === 1" v-if="isUpload">
            <p class="title">附件上传
                <span class="text-danger">
                    (注:材料图片要展现全貌、清晰可辨且将无关的背景内容去掉。图片大小1MB以下避免提交失败。)
                </span>
            </p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 2">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo.taskApply"
                     v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!--第四页（提交确认）-->
        <div v-show="active === 3">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData"
                              :showPropList="baseInfoList"
                              @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步
                </van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, DatetimePicker} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import BasicInformation from "@/components/declare/BasicInformation"
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/custom/InformationShow"
    // import CustomForm from './custom/CustomForm';
    import {taskApiMap} from "@/api/task";
    // import {userInfoCardType, userCompCardType} from './dict/index'
    import {phoneRegex, idCardRegex,cardNumRegex,emailRegexlian,emailNumRegex} from '@/utils/regex'
    import {emailRegex} from "../../../../utils/regex";
    import { baseApiMap } from '@/api/base'

    export default {
        name: "StandardMatter",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            BasicInformation,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                showPickerSex: false, // 是否显示性别选择框
                showPickerHJProvince1: false, // 是否显示户籍省选择框
                HJCityShow1: false, // 是否显示户籍市
                HJAreaShow1: false, // 是否显示户籍区县
                showPickerHJCity1: false, // 是否显示户籍市选择框
                showPickerHJArea1: false, // 是否显示户籍区县选择框

                showPickerHJProvince2: false, // 是否显示户籍省选择框
                HJCityShow2: false, // 是否显示户籍市
                HJAreaShow2: false, // 是否显示户籍区县
                showPickerHJCity2: false, // 是否显示户籍市选择框
                showPickerHJArea2: false, // 是否显示户籍区县选择框

                showPickerHJProvince3: false, // 是否显示户籍省选择框
                HJCityShow3: false, // 是否显示户籍市
                HJAreaShow3: false, // 是否显示户籍区县
                showPickerHJCity3: false, // 是否显示户籍市选择框
                showPickerHJArea3: false, // 是否显示户籍区县选择框

                showPickerHJProvince4: false, // 是否显示户籍省选择框
                HJCityShow4: false, // 是否显示户籍市
                HJAreaShow4: false, // 是否显示户籍区县
                showPickerHJCity4: false, // 是否显示户籍市选择框
                showPickerHJArea4: false, // 是否显示户籍区县选择框

                address: {
                    gj:'中国',
                    shengfen1:'',
                    shiqu1:'',
                    quxian1:'',
                    shengfen2:'',
                    shiqu2:'',
                    quxian2:'',
                    shengfen3:'',
                    shiqu3:'',
                    quxian3:'',
                    shengfen4:'',
                    shiqu4:'',
                    quxian4:''
                },
                data: {
                    family: {},
                    num: 0,
                    max: 10
                },
                provinceList:[],
                cityHJList1:[],
                areaHJList1:[],
                cityHJList2:[],
                areaHJList2:[],
                cityHJList3:[],
                areaHJList3:[],
                cityHJList4:[],
                areaHJList4:[],

                flag: '', //办理方式传过来的状态
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                // userInfoCardTypeOptions: userInfoCardType, // 申请经办人证件类型列表
                compCardTypeOptions: [{id: '企业', name: '企业'}], // 企业类型列表
                // userCompCardTypeOptions: userCompCardType, // 法人证件类型列表
                showUserInfoPickerCardType: false, // 证件类型选择框展示状态
                showCompPickerCardType: false, // 企业类型选择框展示状态
                showUserCompPickerCardType: false, // 法人证件类型选择框展示状态
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                baseInfoList: [], // 展示组件展示的基本信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                informationShowData: { // 展示信息
                    userInfoName: '', // 姓名（展示信息）
                    userInfoPhone: '', // 经办人手机号
                    userInfoCardTypeName: '身份证',
                    userInfoCardType: 10, // 证件类型
                    userInfoCardNum: '', // 身份证（展示信息）
                    compName: '', // 企业名称（展示信息）
                    compType: '', // 企业类型
                    compTypeName: '', // 企业类型名称（展示信息）
                    compCode: '', // 社会信用代码
                    compRepresentative: '', // 法定代表人
                    userCompCardTypeName: '', // 法人证件类型名称
                    userCompCardType: '', // 法人证件类型
                    userCompCardNum: '', // 法人证件号码
                    userCompName: '', // 法定联系人
                    userCompPhone: '', // 法定联系人电话号码
                    compLinkAddress: '', // 法定联系人地址
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '' // 工本费（展示信息）
                },
                declareInfo: {
                    // 标准事项
                    taskApply: {
                        matNum: '', // 事项编号
                        deptId: '', // 所选公安部门id
                        // linkAddress: '', // 联系地址
                        linkAddress: 'null', // 联系地址
                        linkPhone: '', // 电话号码
                        netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                        tskSource: 'SYS', // 申报来源(写死)
                        isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付
                        wfId: '', // 工作流id
                        manifests: [], // 存放附件信息
                        accountId: this.$cookie.getUser().acountId, // 注册的电话号码
                        addressGuidQj: '', // 邮寄地址上门Guid
                        addressGuidSh: '', // 邮寄地址送件Guid
                        qjMoney: '', // 取件费用
                        shMoney: '', // 收件费用
                        gbMoney: '', // 工本费
                        emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件
                    },
                    // 定制化事项
                    body: {
                        /**
                         * 申请人姓名
                         */
                        sqrxm :'',
                        /**
                         * 申请人居民身份号
                         */
                        sqrjmsfzh :'',
                        /**
                         * 申请人联系电话
                         */
                        sqrlxdh :'',
                        /**
                         * 法人代表姓名
                         */
                        frxm :'',
                        /**
                         * 法人代表居民身份号
                         */
                        frjmsfzh :'',
                        /**
                         * 法人代表联系电话
                         */
                        frlxdh :'',
                        /**
                         * 法人代表家庭住址
                         */
                        frjtzz :'',
                        /**
                         * 主要负责人姓名
                         */
                        zyfzrxm :'',
                        /**
                         * 主要负责人居民身份号
                         */
                        zyfzrjmsfzh :'',
                        /**
                         * 主要负责人联系电话
                         */
                        zyfzrlxdh :'',
                        /**
                         * 主要负责人家庭住址
                         */
                        zyfzrjtzz :'',
                        /**
                         * 保卫负责人姓名
                         */
                        bwfzrxm :'',
                        /**
                         * 保卫负责人居民身份号
                         */
                        bwfzrjmsfzh :'',
                        /**
                         * 保卫负责人联系电话
                         */
                        bwfzrlxdh :'',
                        /**
                         * 保卫负责人家庭住址
                         */
                        bwfzrjtzz :'',
                        /**
                         * 营业执照名称
                         */
                        yyzzmc :'',
                        /**
                         * 旅馆招牌名称
                         */
                        lgzpmc :'',
                        /**
                         * 营业执照编号
                         */
                        yyzzhm :'',
                        /**
                         * 邮政编号
                         */
                        yzbm :'',
                        /**
                         * 旅馆标准地址
                         */
                        lgbzdz :'',
                        /**
                         * 旅馆附属场所
                         */
                        lgfscs :'',
                        /**
                         * 单位电话
                         */
                        dwmc :'',
                        /**
                         * 注册资金
                         */
                        zczj :'',
                        /**
                         * 建筑结构
                         */
                        jzjg :'',
                        /**
                         * 营业面积
                         */
                        yymj :'',
                        /**
                         * 客房数
                         */
                        kfs :'',
                        /**
                         * 床位数
                         */
                        cws :'',
                        /**
                         * 从业人数
                         */
                        cyrs :'',
                        /**
                         * 保卫人数
                         */
                        bwrs :'',
                    }
                },
                customFormInfo: {
                    username: '',
                    deptId: '',
                    isMail: true
                },
            }
        },
        mounted() {
            this.getMatterInfo()
            this.getUserInfo()
            this.getProvinceData()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            onConfirm(value) {
                console.log(value)
                this.declareInfo.body.isgzzaxt = value
                this.showPickerSex = false
                // Toast(`当前值：${value}, 当前索引：${index}`);
            },
            // /**
            //  * 选择性别
            //  */
            // onConfirmSex(value) {
            //     this.userInfo.xbmc = value.name
            //     this.userInfo.sqr1_xb = value.key
            //     this.showPickerSex = false
            // },
            /**
             * 获取省
             */
            async getProvinceData() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.provinceList = arr
                } catch (error) {
                    Toast('服务器运行失败')
                    console.log(error);
                }
            },
            /**
             * 获取市
             */
            async getHJCityData1(value) {
                try {
                    this.cityHJList1 = []
                    this.areaHJList1 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityHJList1 = arr
                    if (this.cityHJList1.length > 0) {
                        this.HJCityShow1 = true
                    } else {
                        this.HJCityShow1 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            async getHJCityData2(value) {
                try {
                    this.cityHJList2 = []
                    this.areaHJList2 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityHJList2 = arr
                    if (this.cityHJList2.length > 0) {
                        this.HJCityShow2 = true
                    } else {
                        this.HJCityShow2 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            async getHJCityData3(value) {
                try {
                    this.cityHJList3 = []
                    this.areaHJList3 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityHJList3 = arr
                    if (this.cityHJList3.length > 0) {
                        this.HJCityShow3 = true
                    } else {
                        this.HJCityShow3 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            async getHJCityData4(value) {
                try {
                    this.cityHJList4 = []
                    this.areaHJList4 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.cityHJList4 = arr
                    if (this.cityHJList4.length > 0) {
                        this.HJCityShow4 = true
                    } else {
                        this.HJCityShow4 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取地区
             */
            async getHJAreaData1(value) {
                try {
                    this.areaHJList1 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaHJList1 = arr
                    if (this.areaHJList1.length > 0) {
                        this.HJAreaShow1 = true
                    } else {
                        this.HJAreaShow1 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            }, async getHJAreaData2(value) {
                try {
                    this.areaHJList2 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaHJList2 = arr
                    if (this.areaHJList2.length > 0) {
                        this.HJAreaShow2 = true
                    } else {
                        this.HJAreaShow2 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            async getHJAreaData3(value) {
                try {
                    this.areaHJList3 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaHJList3 = arr
                    if (this.areaHJList3.length > 0) {
                        this.HJAreaShow3 = true
                    } else {
                        this.HJAreaShow3 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            async getHJAreaData4(value) {
                try {
                    this.areaHJList4 = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                        }
                    }
                    this.areaHJList4 = arr
                    if (this.areaHJList4.length > 0) {
                        this.HJAreaShow4 = true
                    } else {
                        this.HJAreaShow4 = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 选择户籍地址省
             */
            onConfirmHJProvince1(value) {
                this.address.shengfen1 = value.title
                this.address.shiqu1 = ''
                this.address.quxian1 = ''
                this.showPickerHJProvince1 = false
                this.getHJCityData1(value.val)
            },
            onConfirmHJProvince2(value) {
                this.address.shengfen2 = value.title
                this.address.shiqu2 = ''
                this.address.quxian2 = ''
                this.showPickerHJProvince2 = false
                this.getHJCityData2(value.val)
            },
            onConfirmHJProvince3(value) {
                this.address.shengfen3 = value.title
                this.address.shiqu3 = ''
                this.address.quxian3 = ''
                this.showPickerHJProvince3 = false
                this.getHJCityData3(value.val)
            },
            onConfirmHJProvince4(value) {
                this.address.shengfen4 = value.title
                this.address.shiqu4 = ''
                this.address.quxian4 = ''
                this.showPickerHJProvince4 = false
                this.getHJCityData4(value.val)
            },
            /**
             * 选择户籍地址市
             */
            onConfirmHJCity1(value) {
                this.showPickerHJCity1 = false
                this.address.shiqu1 = value.title
                this.address.quxian1 = ''
                this.getHJAreaData1(value.val)
            },
            onConfirmHJCity2(value) {
                this.showPickerHJCity2 = false
                this.address.shiqu2 = value.title
                this.address.quxian2 = ''
                this.getHJAreaData2(value.val)
            },
            onConfirmHJCity3(value) {
                this.showPickerHJCity3 = false
                this.address.shiqu3 = value.title
                this.address.quxian3 = ''
                this.getHJAreaData3(value.val)
            },
            onConfirmHJCity4(value) {
                this.showPickerHJCity4 = false
                this.address.shiqu4 = value.title
                this.address.quxian4 = ''
                this.getHJAreaData4(value.val)
            },
            /**
             * 选择户籍区县
             */
            onConfirmHJArea1(value) {
                this.showPickerHJArea1 = false
                this.address.quxian1 = value.title
            },
            onConfirmHJArea2(value) {
                this.showPickerHJArea2 = false
                this.address.quxian2 = value.title
            },
            onConfirmHJArea3(value) {
                this.showPickerHJArea3 = false
                this.address.quxian3 = value.title
            },
            onConfirmHJArea4(value) {
                this.showPickerHJArea4 = false
                this.address.quxian4 = value.title
            },
            /**
             * 选择的办理方式
             * status false:窗口办理 true:邮寄服务
             */
            getStatus(status) {
                this.flag = status
            },
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.taskApply.matNum = this.matterInfo.matNum
                    this.declareInfo.taskApply.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    this.declareInfo.taskApply.wfId = this.matterInfo.wfId
                    // 事项名称和事项编号赋值 事项编码
                    this.declareInfo.body.sxbm = this.matterInfo.guid
                    this.declareInfo.body.sxmc = this.matterInfo.matName
                    this.declareInfo.body.sxbh = this.matterInfo.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    console.log(this.$cookie.getUser())
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = ''
                    }
                    this.userInfo.fullAddress = fullAddress
                    // this.declareInfo.taskApply.linkAddress = fullAddress
                    // this.declareInfo.body.jbrlxdz = fullAddress
                    this.declareInfo.taskApply.linkPhone = this.userInfo.telephone
                    this.declareInfo.body.sqrlxdh = this.userInfo.telephone
                    this.declareInfo.body.sqrxm = this.userInfo.realName
                    this.declareInfo.body.sqrjmsfzh = this.userInfo.idNum

                }
            },
            /**
             * 检查基本信息
             */
            checkBaseInformation() {
                if (!this.declareInfo.body.sqrxm.trim()) {
                    Toast('请输入申请人姓名')
                    return false
                }
                if (!this.declareInfo.body.sqrlxdh.trim()) {
                    Toast('请输入申请人手机号')
                    return false
                }
                if(!phoneRegex(this.declareInfo.body.sqrlxdh)) {
                    Toast('请输入正确的申请人手机号')
                    return false
                }
                // if (!this.declareInfo.body.fzrxm) {
                //     Toast('请选择经办人证件类型')
                //     return false
                // }
                if (!this.declareInfo.body.sqrjmsfzh) {
                    Toast('请输入申请人身份证')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.sqrjmsfzh)) {
                    Toast('请输入正确的申请人证件号码')
                    return false
                }
                //法人信息
                if (!this.declareInfo.body.frxm.trim()) {
                    Toast('请输入法人代表姓名')
                    return false
                }
                if (!this.declareInfo.body.frjmsfzh) {
                    Toast('请输入法人身份证')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.frjmsfzh)) {
                    Toast('请输入正确的法人证件号码')
                    return false
                }
                if (!this.declareInfo.body.frlxdh) {
                    Toast('请输入法人联系电话')
                    return false
                }
                if(!phoneRegex(this.declareInfo.body.frlxdh)) {
                    Toast('请输入正确的法人联系电话')
                    return false
                }
                if (!this.declareInfo.body.frjtzz) {
                    Toast('请输入法人家庭地址')
                    return false
                }
                //负责人信息
                if (!this.declareInfo.body.zyfzrxm.trim()) {
                    Toast('请输入主要负责人姓名')
                    return false
                }
                if (!this.declareInfo.body.zyfzrjmsfzh) {
                    Toast('请输入主要负责人身份证')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.zyfzrjmsfzh)) {
                    Toast('请输入正确的主要负责人证件号码')
                    return false
                }
                if (!this.declareInfo.body.zyfzrlxdh) {
                    Toast('请输入主要负责人联系电话')
                    return false
                }
                if(!phoneRegex(this.declareInfo.body.zyfzrlxdh)) {
                    Toast('请输入正确的主要负责人联系电话')
                    return false
                }
                if (!this.declareInfo.body.zyfzrjtzz) {
                    Toast('请输入主要负责人家庭地址')
                    return false
                }
                //技术员信息
                if (!this.declareInfo.body.bwfzrxm.trim()) {
                    Toast('请输入保卫负责人姓名')
                    return false
                }
                if (!this.declareInfo.body.bwfzrjmsfzh) {
                    Toast('请输入保卫负责人身份证')
                    return false
                }
                if(!idCardRegex(this.declareInfo.body.bwfzrjmsfzh)) {
                    Toast('请输入正确的保卫负责人证件号码')
                    return false
                }
                if (!this.declareInfo.body.bwfzrlxdh) {
                    Toast('请输入保卫负责人联系电话')
                    return false
                }
                if(!phoneRegex(this.declareInfo.body.bwfzrlxdh)) {
                    Toast('请输入正确的保卫负责人联系电话')
                    return false
                }
                if (!this.declareInfo.body.bwfzrjtzz) {
                    Toast('请输入保卫负责人家庭地址')
                    return false
                }

                if (!this.declareInfo.body.yyzzmc) {
                    Toast('请输入营业执照名称')
                    return false
                }
                if (!this.declareInfo.body.lgzpmc) {
                    Toast('请输入旅馆招牌名称')
                    return false
                }
                if (!this.declareInfo.body.yyzzhm) {
                    Toast('请输入营业执照编号')
                    return false
                }
                if (!this.declareInfo.body.yzbm) {
                    Toast('请输入邮政编码')
                    return false
                }
                if (!this.declareInfo.body.lgbzdz) {
                    Toast('请输入旅馆附属场所')
                    return false
                }
                if (!this.declareInfo.body.dwmc) {
                    Toast('请输入单位电话')
                    return false
                }
                if (!phoneRegex(this.declareInfo.body.dwmc)) {
                    Toast('请输入正确的单位联系电话')
                    return false
                }
                if (!this.declareInfo.body.zczj) {
                    Toast('请输入注册资金')
                    return false
                }
                if (!this.declareInfo.body.jzjg) {
                    Toast('请输入单位建筑结构')
                    return false
                }
                if (!this.declareInfo.body.yymj) {
                    Toast('请输入单位营业面积')
                    return false
                }
                if (!this.declareInfo.body.kfs) {
                    Toast('请输入客房数')
                    return false
                }
                if (!this.declareInfo.body.cws) {
                    Toast('请输入床位数')
                    return false
                }
                if (!this.declareInfo.body.cyrs) {
                    Toast('请输入单位从业人数')
                    return false
                }
                if (!this.declareInfo.body.bwrs) {
                    Toast('请输入单位保卫人数')
                    return false
                }
                return true
            },
            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                console.log(this.declareInfo)
                Toast.clear()
                // this.userInfo.fullAddress = this.declareInfo.body.jbrlxdz
                // this.declareInfo.taskApply.linkAddress = this.declareInfo.body.jbrlxdz
                // 验证基本信息
                this.$refs.selectpolice.setDeptId() // 部门赋值
                if (!this.declareInfo.deptId) {
                    Toast('请选择公安机关')
                    return
                }else{
                    this.declareInfo.taskApply.deptId = this.declareInfo.deptId
                }
                if (!this.checkBaseInformation()) {
                    return;
                }
                if (index === 1) { // 申报信息页面验证
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 2) { // 附件上传页面验证
                    this.declareInfo.taskApply.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        // 到第三页传值
                        this.sendCustomInfomation()
                        this.active = 3
                    }
                } else if (index === 3) {
                    this.$refs.mailingChildFunction.passMailingValue()
                    if (this.flag === false) { // false:窗口办理 true:邮寄服务
                        this.informationShowData.mailingShow = false
                        this.declareInfo.taskApply.isMailMertal = '0'
                        this.active = 3
                    } else { // 邮寄服务
                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                        this.declareInfo.taskApply.isMailMertal = '101' // 办理方式：'0'窗口办理，'101'邮寄

                        if (this.declareInfo.taskApply.emsConfig === '3' && !this.declareInfo.taskApply.addressGuidQj) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.taskApply.emsConfig === '1' && !this.declareInfo.taskApply.addressGuidSh) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.taskApply.emsConfig === '2' && !this.declareInfo.taskApply.addressGuidQj && !this.declareInfo.taskApply.addressGuidSh) {
                            Toast('请至少选择一种邮寄方式')
                            return
                        }

                        if (this.declareInfo.taskApply.addressGuidQj && this.declareInfo.taskApply.addressGuidSh) {//两者都选
                            this.informationShowData.mailingStatus = '2'
                        } else if (this.declareInfo.taskApply.addressGuidQj) { // 二选一
                            // 选择了取件地址
                            this.informationShowData.mailingStatus = '3'
                            this.declareInfo.taskApply.addressGuidSh = ''
                        } else if (this.declareInfo.taskApply.addressGuidSh) {
                            // 选择了收件地址
                            this.informationShowData.mailingStatus = '1'
                            this.declareInfo.taskApply.addressGuidQj = ''
                        }
                    }
                    // 到第三页传值
                    this.sendCustomInfomation()
                    this.active = 3

                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }
            },

            /**
             * 传给定制化展示组件基本信息
             */
            sendCustomInfomation() {
                const baseInfoList = [
                    {title: '申请经办人', prop: this.declareInfo.body.sqrxm},
                    {title: '经办人手机号码', prop: this.declareInfo.body.sqrlxdh},
                    {title: '经办人证件类型', prop: '居民身份证'},
                    {title: '经办人证件号码', prop: this.declareInfo.body.sqrjmsfzh},
                ]
                this.baseInfoList = baseInfoList
            },

            /**
             * 接收上传图片组件传来的image列表
             * @param value image列表
             */
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.declareInfo.taskApply.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },
            getFamilyInfo(value) {
                this.declareInfo.body.glry = []
                this.declareInfo.body.glry = value
                console.log(this.declareInfo)
            },
            /**
             * 接收是否上传图片的状态
             * @param value 是否上传了图片状态
             */
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            /**
             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
             * @param value 布尔值
             */
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            /**
             * 接收邮寄信息组件
             * @param value 布尔值
             */
            getMailingData(value) {
                this.declareInfo.taskApply.addressGuidQj = value.addressGuidQj
                this.declareInfo.taskApply.addressGuidSh = value.addressGuidSh
                this.declareInfo.taskApply.qjMoney = value.qjMoney
                this.declareInfo.taskApply.shMoney = value.shMoney
                this.declareInfo.taskApply.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },
            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                try {
                    // debugger
                    // 对地址进行拼接
                    this.declareInfo.body.frjtzz = this.address.gj + this.address.shengfen1 + this.address.shiqu1 + this.address.quxian1 + this.declareInfo.body.frjtzz
                    this.declareInfo.body.zyfzrjtzz = this.address.gj + this.address.shengfen2 + this.address.shiqu2 + this.address.quxian2 + this.declareInfo.body.zyfzrjtzz
                    this.declareInfo.body.bwfzrjtzz = this.address.gj + this.address.shengfen3 + this.address.shiqu3 + this.address.quxian3 + this.declareInfo.body.bwfzrjtzz
                    this.declareInfo.body.lgbzdz = this.address.gj + this.address.shengfen4 + this.address.shiqu4 + this.address.quxian4 + this.declareInfo.body.lgbzdz
                    console.log(this.declareInfo.toString())
                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.zaHotelTsks, this.declareInfo)
                    if (res.data.succ) {
                        Toast.clear()
                        if (this.informationShowData.mailingShow === 'Y') {
                            Dialog.alert({
                                title: '申报成功',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })
                        } else {
                            Dialog.alert({
                                title: '申报成功，预审通过后，您可以携带相关办件材料至窗口办理',
                                message: `您的办件编号为:${res.data.data}`
                            }).then(() => {
                                this.$router.push('/myHandlingList')
                            })
                        }

                    } else {
                        Toast.fail('申报失败')
                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>

<style>
    .approve-company-box .van-field__label {
        width: 2.5rem;
    }
</style>